export var props = {
  roomEggs: {
    type: Array,
    required: false,
    default: () => []
  },
  workEggs: {
    type: Array,
    required: false,
    default: () => []
  },
  eggColumns: {
    type: Array,
    required: false,
    default: () => []
  },
  dataFormatter: {
    type: Function,
    required: false
  },
  sort: {
    type: [String, Object, undefined],
    default: undefined
  },
  isPreview: {
    type: Boolean,
    required: false,
    default: false
  }
};